<template>
  <div class="nobind">
    <template v-if="isBinding && !isBindSuccess">
      <div class="title" v-if="failed_tips">{{ failed_tips }}</div>
      <div class="title" v-else>绑定失败</div>
      <div class="title-tips">扫码添加客服获取帮助</div>
      <div class="failed-qrcode"></div>
      <div class="failed-sure-btn" @click="onCancelClick">确定</div>
    </template>
    <template v-else-if="isBinding && isBindSuccess">
      <div class="title">绑定成功</div>
      <div class="title-tips">{{ name }}</div>
      <div class="success-icon"></div>
      <div class="failed-sure-btn" @click="onRefreshClick">确定</div>
    </template>
    <template v-else>
      <div
        class="title"
        v-if="
          !(
            ($store.state.client == 'mac' ||
              $store.state.client == 'windows') &&
            $store.state.version > '2.3.2'
          ) || true
        "
      >
        绑定设备
      </div>
      <div class="title-icon"></div>
      <div class="code-wrap">
        <div class="tips">{{ inputTips }}</div>
        <input
          v-model="activecode"
          v-on:input="inputFun()"
          @focus="onInputFocus"
          @blur="onInputBlur"
          @keydown.enter="bindDeviceClick"
        />
      </div>
      <div class="btn" @click="bindDeviceClick">立即绑定</div>

      <div class="getcode" @click="showDownloadClick">
        <div class="getcode-icon"></div>
        如何获取绑定码？
      </div>

      <div
        class="server-btn"
        @click="goServerPage"
        v-if="
          ($store.state.client == 'mac' || $store.state.client == 'windows') &&
          $store.state.version > '2.3.2'
        "
      >
        <span class="btn-title">切换设备端</span
        ><span class="btn-tips">（获取绑定码）</span>
      </div>
      <div
        class="know-us"
        v-if="show && !$store.getters.isAppstoreMode && false"
      >
        <div class="know-text">小宝可以为我做什么？</div>
        <div class="know-btn" @click="knowClick">
          了解详情
          <div class="know-icon"></div>
        </div>
        <div class="close" @click="closeClick"></div>
      </div>
    </template>
    <Download v-if="$store.state.isShowDownload == 1"></Download>
    <ChooseFirm v-if="$store.state.isShowDownload == 2"></ChooseFirm>
    <DownloadQh v-if="$store.state.isShowDownload == 3"></DownloadQh>
    <DownloadWlt v-if="$store.state.isShowDownload == 4"></DownloadWlt>
    <DownloadTwm v-if="$store.state.isShowDownload == 5"></DownloadTwm>
    <DownloadLx v-if="$store.state.isShowDownload == 6"></DownloadLx>
    <DownloadHk v-if="$store.state.isShowDownload == 7"></DownloadHk>
    <DownloadWin v-if="$store.state.isShowDownload == 8"></DownloadWin>
    <DownloadMac v-if="$store.state.isShowDownload == 9"></DownloadMac>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Download from "@/components/remote/Download.vue";
import ChooseFirm from "@/components/remote/ChooseFirm.vue";
import DownloadQh from "@/components/remote/DownloadQh.vue";
import DownloadWlt from "@/components/remote/DownloadWlt.vue";
import DownloadTwm from "@/components/remote/DownloadTwm.vue";
import DownloadLx from "@/components/remote/DownloadLx.vue";
import DownloadHk from "@/components/remote/DownloadHk.vue";
import DownloadWin from "@/components/remote/DownloadWin.vue";
import DownloadMac from "@/components/remote/DownloadMac.vue";

export default {
  data: function () {
    return {
      activecode: "",
      inputTips: "输入绑定码",
      isBinding: false,
      isBindSuccess: false,
      bindRtn: 0,
      show: true,
      failed_tips: "",
      name: "",
    };
  },
  components: {
    Download,
    ChooseFirm,
    DownloadQh,
    DownloadWlt,
    DownloadTwm,
    DownloadLx,
    DownloadHk,
    DownloadWin,
    DownloadMac,
  },
  methods: {
    ...mapActions(["sendUserlog", "bookRegister"]),
    onRefreshClick: function () {
      window.location.reload();
    },
    onCancelClick: function () {
      this.isBinding = false;
      this.bindRtn = 0;
    },
    goServerPage: function () {
      let _that = this;
      if (process.env.NODE_ENV !== "production") {
        window.location.href =
          "http://192.168.71.34:8081/?client=" +
          _that.$store.state.client +
          "&version=" +
          _that.$store.state.version;
      } else {
        window.location.href =
          "http://yc.iepose.com/jdxb_server_pc_v4/?client=" +
          _that.$store.state.client +
          "&version=" +
          _that.$store.state.version;
      }
    },
    showDownloadClick: function () {
      let _that = this;
      _that.$store.state.isShowDownload = 1;
    },
    knowClick: function () {
      let _that = this;
      _that.$router.push("/home/help");
    },
    closeClick: function () {
      let _that = this;
      _that.show = false;
    },
    onInputFocus: function () {
      this.inputTips = "";
    },
    onInputBlur: function () {
      if (!this.activecode) {
        this.inputTips = "输入绑定码";
      }
    },
    bindDeviceClick: function () {
      let _that = this;
      if (!_that.activecode) {
        _that.$store.state.toast = "请输入绑定码";
        return;
      } else if (_that.activecode.length < 6) {
        _that.$store.state.toast = "绑定码无效";
        return;
      }
      _that.isBinding = true;
      _that.bindRtn = 0;
      _that.bookRegister([
        _that.activecode,
        function (err, data) {
          _that.bindRtn = data.rtn;
          if (data && !data.rtn && data.register) {
            _that.$store.state.toast = "绑定成功";
            setTimeout(function () {
              _that.$emit("closeAddDeviceClick");
            }, 3000);

            _that.$emit("getBindget");

            _that.$store.state.isLoadForBind = true;
            _that.isBindSuccess = true;
            _that.sendUserlog(["bindDevice_s", _that.activecode]);
          } else {
            _that.isBindSuccess = false;
            _that.failed_tips = "设备绑定失败";
            setTimeout(function () {
              _that.$emit("closeAddDeviceClick");
            }, 3000);

            if (_that.bindRtn == 10112) {
              _that.failed_tips = "设备已被绑定";
            }

            // 绑定失败
            if (data && data.rtn == 10216) {
              _that.sendUserlog([
                "bindDevice_f_limit",
                _that.activecode + "|10216",
              ]);
            } else {
              _that.sendUserlog([
                "bindDevice_f",
                _that.activecode + "|" + data.rtn,
              ]);
            }
          }
        },
      ]);
    },

    // bindDeviceClick: function () {
    //   let _that = this;
    //   if (!_that.activecode) {
    //     _that.$store.state.toast = "请输入绑定码";
    //     return;
    //   } else if (_that.activecode.length < 6) {
    //     _that.$store.state.toast = "绑定码无效";
    //     return;
    //   }
    //   _that.bindDeviceClick();
    //   //   _that.$emit("bindDeviceClick", _that.activecode);
    // },
    inputFun: function () {
      let _that = this;
      if (_that.activecode.length > 6) {
        _that.activecode = _that.activecode.slice(0, 6);
      }
    },
  },
  mounted: function () {
    let _that = this;
    _that.sendUserlog(["no_bind_alert", ""]);
  },
};
</script>

<style lang="less" scoped>
.nobind {
  padding-top: 1px;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  .title {
    margin-top: 110px;
    text-align: center;
    color: #1a1a1a;
    font-family: PingFang SC;
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px; /* 100% */
  }
  .title-tips {
    color: rgba(0, 0, 0, 0.7);
    text-align: center;
    font-family: PingFang SC;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-top: 12px;
  }
  .failed-qrcode {
    width: 126px;
    height: 126px;
    margin: 0 auto;
    margin-top: 28px;
    background-color: #cccccc;
    // background-image: url(../../assets/common/kf_qrcode.jpg);
    background-image: url(../../assets/remote/bindf2.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    border: 5px solid #ffffff;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  }
  .failed-sure-btn {
    width: 164px;
    height: 48px;
    line-height: 48px;
    text-align: center;
    color: #ffffff;
    font-size: 16px;
    font-weight: bolder;
    border-radius: 20px;
    margin: 0 auto;
    margin-top: 60px;
    border-radius: 24px;
    background-color: #3535c1;
    background-image: var(
      --unnamed,
      linear-gradient(188deg, #655de1 0%, #3535c1 100%)
    );
    box-shadow: 0px 4px 8px 0px rgba(25, 24, 106, 0.16);
  }
  .failed-sure-btn:hover {
    cursor: pointer;
    opacity: 0.9;
  }
  .success-icon {
    background-image: url(../../assets/speedShare/success_icon.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    width: 50px;
    height: 50px;
    margin: 0 auto;
    margin-top: 40px;
  }
  .title-icon {
    width: 105px;
    height: 79px;
    background-image: url(../../assets/home/nobind/tips-icon.png);
    background-size: 100% 100%;
    margin: 0 auto;
    margin-top: 24px;
  }
  .code-wrap {
    position: relative;
    margin: 0 auto;
    margin-top: 23px;
    width: 286px;
    height: 48px;
    // border: 1px solid #cbcdd1;
    box-shadow: 0px 2px 6px rgba(201, 206, 210, 0.3);
    border-radius: 86px;
    overflow: hidden;
    background-color: #fcfdff;

    .tips {
      position: absolute;
      left: 0;
      top: 0;
      width: 286px;
      height: 48px;
      text-align: center;
      line-height: 48px;
      font-size: 16px;
      color: #666666;
    }
    input {
      position: absolute;
      left: 0;
      top: 0;
      text-align: center;
      width: 286px;
      height: 48px;
      background-color: transparent;
      letter-spacing: 10px;
      color: #143977;
      font-weight: 700;
      font-size: 24px;
      font-family: "DIN";
    }
  }
  .btn {
    margin: 0 auto;
    margin-top: 24px;
    width: 286px;
    height: 48px;
    background-color: #3535c1;
    background-image: linear-gradient(188deg, #655de1 0%, #3535c1 100%);
    box-shadow: 0px 4px 8px 0px rgba(25, 24, 106, 0.16);
    border-radius: 24px;
    font-weight: 700;
    font-size: 16px;
    line-height: 48px;
    text-align: center;
    color: #fcfcfc;
    cursor: pointer;
  }
  .server-btn {
    margin: 0 auto;
    margin-top: 24px;
    width: 286px;
    height: 48px;
    background-color: #c98657;
    background-image: linear-gradient(
      180deg,
      #dfa176 0%,
      #c98657 0.01%,
      #dda177 100%
    );
    box-shadow: 0px 4px 12px rgba(172, 178, 186, 0.2);
    border-radius: 24px;
    font-weight: 700;
    font-size: 16px;
    line-height: 48px;
    text-align: center;
    color: #fcfcfc;
    cursor: pointer;
    .btn-tips {
      font-size: 12px;
    }
  }
  .btn:hover,
  .server-btn:hover {
    cursor: pointer;
    opacity: 0.9;
  }
  .getcode {
    margin-top: 15px;
    text-align: center;
    font-size: 14px;
    line-height: 22px;
    color: #615cd8;
    cursor: pointer;
    .getcode-icon {
      display: inline-block;
      margin-right: 4px;
      vertical-align: top;
      width: 20px;
      height: 20px;
      background-image: url("../../assets/home/nobind/warn.svg");
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
  }
  .know-us {
    position: absolute;
    left: 35px;
    bottom: 40px;
    padding-top: 1px;
    width: 908px;
    height: 102px;
    background-image: url("../../assets/remote/strength.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    box-sizing: border-box;
    .know-text {
      margin-top: 21px;
      margin-left: 156px;
      font-weight: 600;
      font-size: 16px;
      line-height: 21px;
      color: #4a4a4a;
    }
    .know-btn {
      padding-left: 16px;
      margin-left: 156px;
      margin-top: 9px;
      width: 96px;
      height: 28px;
      border: 1px solid #8795a5;
      border-radius: 24px;
      color: #133875;
      font-size: 12px;
      line-height: 28px;
      text-align: left;
      box-sizing: border-box;
      cursor: pointer;
      .know-icon {
        display: inline-block;
        margin-top: 4px;
        margin-left: 4px;
        vertical-align: top;
        width: 20px;
        height: 20px;
        background-image: url("../../assets/remote/right.svg");
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
    }
    .know-btn:hover {
      opacity: 0.9;
    }
    .close {
      position: absolute;
      right: 0;
      top: 0;
      width: 48px;
      height: 48px;
      background-image: url("../../assets/remote/close.svg");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      cursor: pointer;
    }
  }
}
</style>